import { render, staticRenderFns } from "./AppPaginacionEstandar.vue?vue&type=template&id=22be9f2c&scoped=true"
import script from "./AppPaginacionEstandar.vue?vue&type=script&lang=js"
export * from "./AppPaginacionEstandar.vue?vue&type=script&lang=js"
import style0 from "./AppPaginacionEstandar.vue?vue&type=style&index=0&id=22be9f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be9f2c",
  null
  
)

export default component.exports